export default __webpack_public_path__ + "static/media/2090-01.7408e93b.jpg";